import { h, Host, } from "@stencil/core";
import state from "../store";
import { exportParts } from "../../common/export-parts";
export class GxgTabBar {
    parts = {
        buttonMenu: "button-menu",
    };
    exportparts;
    constructor() {
        this.hidden = false;
        this.appendedButtons = 0;
        this.tabBarMenuHeight = "auto";
        this.tabBarMenuWidth = "auto";
        this.tabBarMenuCollapsed = true;
        this.tabBarMenuPosition = undefined;
        this.displayBorder = false;
        this.scrollable = false;
        this.rtl = false;
        this.detectClickOutsideTabBarMenu = this.detectClickOutsideTabBarMenu.bind(this);
    }
    el;
    tabBar;
    tabBarMenu;
    tabBarMenuToggleButton;
    lastAddedOrRemovedTabBarButtonWidth = 0;
    openMenu(event) {
        event.stopPropagation();
        this.tabBarMenuCollapsed = false;
        document.addEventListener("click", this.detectClickOutsideTabBarMenu);
    }
    tabBarMenuCollapsedHandler(menuCollapsed) {
        this.evaluateMenuButtonsTabIndex(menuCollapsed);
        this.setFocus(menuCollapsed);
    }
    evaluateMenuButtonsTabIndex = (menuCollapsed) => {
        if (menuCollapsed) {
            this.disableTabIndex();
        }
        else {
            this.enableTabIndex();
        }
    };
    setFocus = (menuCollapsed) => {
        if (menuCollapsed) {
            this.tabBarMenuToggleButton.focus();
        }
        else {
            const menuButtons = this.el.querySelectorAll("[slot=tab-menu]");
            if (menuButtons.length) {
                menuButtons[0].focus();
            }
        }
    };
    async appendTabButtons() {
        if (!this.scrollable) {
            const numberOfButtons = this.el.querySelectorAll("gxg-tab-button").length;
            for (let i = 0; i <= numberOfButtons; i++) {
                this.appendTabItemsToMenu();
            }
        }
    }
    tabActivatedHandler() {
        this.tabBarMenuCollapsed = true;
    }
    PrevOrNextTabHandler(e) {
        const tabEnabledButtons = [];
        const allTabButtons = this.el.querySelectorAll("gxg-tab-button");
        if (allTabButtons) {
            allTabButtons.forEach((tabButton) => {
                if (!tabButton.disabled && !tabButton.hidden) {
                    tabEnabledButtons.push(tabButton);
                }
            });
        }
        const arrowPressed = e.detail["arrowPressed"];
        const targetButton = e.target;
        const clickedButtonIndex = tabEnabledButtons.findIndex((button) => {
            return button === targetButton;
        });
        let destinationTab;
        if (arrowPressed === "ArrowLeft" && clickedButtonIndex !== -1) {
            destinationTab = tabEnabledButtons[clickedButtonIndex - 1];
        }
        else if (arrowPressed === "ArrowRight" && clickedButtonIndex !== -1) {
            destinationTab = tabEnabledButtons[clickedButtonIndex + 1];
        }
        if (destinationTab) {
            destinationTab.tabButtonClick();
        }
    }
    appendTabItemsToMenu() {
        //This function appends tab-buttons into a tab-menu, as long as the tab-buttons are too tight
        const gxgTabsPosition = this.el.parentElement
            .position;
        const buttonHeight = this.el.children.item(0).clientHeight;
        let sizeReference;
        if (gxgTabsPosition === "top" || gxgTabsPosition === "bottom") {
            sizeReference = this.el.parentElement.offsetWidth;
        }
        else if (gxgTabsPosition === "right" || gxgTabsPosition === "left") {
            sizeReference = this.el.parentElement.offsetHeight;
        }
        const tabBarWidth = this.tabBar.offsetWidth;
        if (tabBarWidth + 20 > sizeReference) {
            const tabButtons = this.el.querySelectorAll("gxg-tab-button[slot='tab-bar']");
            //get the last item of the nodeList
            const lastTabButton = tabButtons[tabButtons.length - 1];
            if (lastTabButton) {
                this.lastAddedOrRemovedTabBarButtonWidth = lastTabButton.offsetWidth;
                //add "menu-button" class to button component, in order to stylize the buttons inside the menu differently
                lastTabButton.classList.add("menu-button");
                lastTabButton.setAttribute("slot", "tab-menu");
                this.appendedButtons++;
            }
            //}
        }
        else if (tabBarWidth + 20 + this.lastAddedOrRemovedTabBarButtonWidth <
            sizeReference) {
            const menuButtons = this.el.querySelectorAll("[slot=tab-menu]");
            const menuFirstButton = menuButtons[0];
            if (menuFirstButton) {
                menuFirstButton.classList.remove("menu-button");
                menuFirstButton.setAttribute("slot", "tab-bar");
                this.lastAddedOrRemovedTabBarButtonWidth = menuFirstButton.offsetWidth;
                this.appendedButtons--;
            }
        }
        if (gxgTabsPosition === "right" || gxgTabsPosition === "left") {
            this.tabBarMenuHeight = this.appendedButtons * buttonHeight + "px";
        }
        this.evaluateMenuButtonsTabIndex(this.tabBarMenuCollapsed);
    }
    componentWillLoad() {
        this.attachExportParts();
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    componentDidLoad() {
        //Reading Direction
        const dirHtml = document
            .getElementsByTagName("html")[0]
            .getAttribute("dir");
        const dirBody = document
            .getElementsByTagName("body")[0]
            .getAttribute("dir");
        if (dirHtml === "rtl" || dirBody === "rtl") {
            this.rtl = true;
        }
        if (!this.scrollable) {
            const myObserver = new ResizeObserver((entries) => {
                entries.forEach(() => {
                    //get any button space between text and button border
                    this.appendTabItemsToMenu();
                });
            });
            myObserver.observe(this.el.parentElement);
            //Collapse buttons if they dont't fit in the available space already
            const numberOfButtons = this.el.querySelectorAll("gxg-tab-button").length;
            for (let i = 0; i <= numberOfButtons; i++) {
                this.appendTabItemsToMenu();
            }
        }
        //Tabbar menu on bottom
        const gxgTabsPosition = this.el.parentElement.getAttribute("position");
        if (gxgTabsPosition === "bottom") {
            this.tabBarMenuPosition = "bottom";
        }
        //Tabbar menu on right
        if (gxgTabsPosition === "right") {
            this.tabBarMenuPosition = "right";
        }
        this.setIndexToTabButtons();
    }
    setIndexToTabButtons() {
        const tabButtons = this.el.querySelectorAll("gxg-tab-button");
        tabButtons.forEach((tabButton, index) => {
            tabButton.setAttribute("data-index", index.toString());
        });
    }
    renderTabBarMenu() {
        if (this.appendedButtons > 0) {
            return (h("div", { class: "tab-bar__menu" }, h("gxg-button", { onClick: this.openMenu.bind(this), type: "tertiary", icon: "gemini-tools/show-more-vertical", ref: (el) => (this.tabBarMenuToggleButton = el), part: this.parts.buttonMenu })));
        }
    }
    detectClickOutsideTabBarMenu(event) {
        const x = event.x;
        const y = event.y;
        //card main container coordinates
        const tabBarMenuClientRect = this.tabBarMenu.getBoundingClientRect();
        if (x > tabBarMenuClientRect.left &&
            x < tabBarMenuClientRect.right &&
            y > tabBarMenuClientRect.top &&
            y < tabBarMenuClientRect.bottom) {
            //Click happened inside the menu
        }
        else {
            //Click happened outside the menu
            this.tabBarMenuCollapsed = true;
        }
    }
    disconnectedCallback() {
        document.removeEventListener("click", this.detectClickOutsideTabBarMenu);
    }
    enableTabIndex = () => {
        const allButtons = this.el.querySelectorAll("gxg-tab-button");
        allButtons.forEach((button) => {
            button.removeAttribute("tabindex");
        });
    };
    disableTabIndex = () => {
        const menuButtons = this.el.querySelectorAll("[slot=tab-menu]");
        menuButtons.forEach((button) => {
            button.setAttribute("tabindex", "-1");
        });
    };
    render() {
        return (h(Host, { class: {
                rtl: this.rtl,
                "gxg-tab-bar": true,
                "gxg-tab-bar--hidden": this.hidden,
                mercury: state.mercury,
            }, exportParts: this.exportparts ? this.exportparts : null }, h("nav", { class: {
                nav: true,
                "nav--border": this.displayBorder,
            } }, h("ul", { class: "tab-bar", ref: (el) => (this.tabBar = el) }, h("slot", { name: "tab-bar" })), this.renderTabBarMenu(), h("ul", { class: {
                "tab-bar-menu": true,
                "tab-bar-menu--collapsed": this.tabBarMenuCollapsed,
                top: this.tabBarMenuPosition === "top",
                right: this.tabBarMenuPosition === "right",
                bottom: this.tabBarMenuPosition === "bottom",
                left: this.tabBarMenuPosition === "left",
            }, style: {
                "--tabBarMenuHeight": this.tabBarMenuHeight,
                "--tabBarMenuWidth": this.tabBarMenuWidth,
            }, ref: (el) => (this.tabBarMenu = el) }, h("slot", { name: "tab-menu" })))));
    }
    static get is() { return "gxg-tab-bar"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tab-bar.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tab-bar.css"]
        };
    }
    static get properties() {
        return {
            "hidden": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Hides the tab-bar"
                },
                "attribute": "hidden",
                "reflect": false,
                "defaultValue": "false"
            },
            "displayBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute displays a border-bottom line on the tab bar"
                },
                "attribute": "display-border",
                "reflect": false,
                "defaultValue": "false"
            },
            "scrollable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute with display a scrollbar if the buttons total width is greater than the tab-bar width."
                },
                "attribute": "scrollable",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "appendedButtons": {},
            "tabBarMenuHeight": {},
            "tabBarMenuWidth": {},
            "tabBarMenuCollapsed": {},
            "tabBarMenuPosition": {},
            "rtl": {}
        };
    }
    static get methods() {
        return {
            "appendTabButtons": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "tabBarMenuCollapsed",
                "methodName": "tabBarMenuCollapsedHandler"
            }];
    }
    static get listeners() {
        return [{
                "name": "tabActivated",
                "method": "tabActivatedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "PrevOrNextTab",
                "method": "PrevOrNextTabHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=tab-bar.js.map
